module.exports = __webpack_public_path__ + "static/media/knowledge.5d67211b.png";